var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeerBitboxedIconSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4348_23147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 0H4C1.79086 0 0 1.79086 0 4V27C0 29.2091 1.79086 31 4 31H27C29.2091 31 31 29.2091 31 27V4C31 1.79086 29.2091 0 27 0Z",
    fill: "#E61B17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.62109 4.61133V17.6772H26.3747V4.61133H4.62109ZM22.2187 13.3262H8.85024V8.97313H22.2187V13.3262Z",
    fill: "#FEFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.62109 22.0366H26.3747V24.7543C26.3744 25.1864 26.2117 25.6008 25.9222 25.907C25.6326 26.2132 25.2397 26.3864 24.8293 26.3887H4.62109V22.0366Z",
    fill: "#FEFDFD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4348_23147"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeerBitboxedIconSvg);
export default __webpack_public_path__ + "static/media/SeerBit boxed Icon SVG.c283cdeaba69253dc60df331e2fd8c1b.svg";
export { ForwardRef as ReactComponent };